export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST'
export const LOGOUT_USER = 'LOGOUT_USER'
export const CONNECT_USER = 'CONNECT_USER'
export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST'
